// src/contentfulClient.js
import { createClient } from 'contentful';

// CONTENTFUL CONFIGURATION
// Daniel will NEVER need to touch this!
// You set it up once, it works forever

const client = createClient({
	space: process.env.REACT_APP_CONTENTFUL_SPACE_ID || 'YOUR_SPACE_ID',
	accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN || 'YOUR_ACCESS_TOKEN',
	host: 'cdn.contentful.com'
});

/**
 * Fetch all photos from Contentful
 * Photos are automatically sorted by category
 */
export const fetchPhotos = async () => {
	try {
		const entries = await client.getEntries({
			content_type: 'photo',
			order: 'fields.order', // Order field lets Daniel control photo order
			limit: 1000
		});

		// Group photos by category
		const photosByCategory = {
			food: [],
			seniors: [],
			maternity: [],
			birthdays: [],
			selflove: [],
			family: [],
			couples: [],
			branding: []
		};

		entries.items.forEach(item => {
			const category = item.fields.category.toLocaleLowerCase();
			const photo = {
				id: item.sys.id,
				src: item.fields.image?.fields?.file?.url
					? `https:${item.fields.image.fields.file.url}`
					: '',
				alt: item.fields.altText || item.fields.title || 'Photography by Daniel Duarte',
				title: item.fields.title || '',
				category: category
			};

			if (photosByCategory[category]) {
				photosByCategory[category].push(photo);
			}
		});

		return photosByCategory;
	} catch (error) {
		console.error('Error fetching photos from Contentful:', error);

		// Return fallback data if Contentful fails
		return {
			food: [],
			seniors: [],
			maternity: [],
			birthdays: [],
			selflove: [],
			family: [],
			couples: [],
			branding: []
		};
	}
};

/**
 * Fetch site settings (about text, contact info, etc.)
 */
export const fetchSiteSettings = async () => {
	try {
		const entries = await client.getEntries({
			content_type: 'siteSettings',
			limit: 1
		});

		if (entries.items.length > 0) {
			return entries.items[0].fields;
		}

		// Fallback settings
		return {
			aboutText: "Based in Massachusetts, I specialize in capturing the moments that matter most.",
			email: "contact@danielduarte.com",
			phone: "(774) 417-1706",
			instagram: "https://www.instagram.com/danielduartephotography"
		};
	} catch (error) {
		console.error('Error fetching site settings:', error);
		return {
			aboutText: "Based in Massachusetts, I specialize in capturing the moments that matter most.",
			email: "contact@danielduarte.com",
			phone: "(774) 417-1706",
			instagram: "https://www.instagram.com/danielduartephotography"
		};
	}
};
/**
 * Fetch service packages from Contentful
 */
export const fetchPackages = async () => {
	try {
		const entries = await client.getEntries({
			content_type: 'package',
			order: 'fields.order'
		});

		return entries.items.map(item => ({
			id: item.sys.id,
			packageName: item.fields.packageName || '',
			price: item.fields.price || '',
			description: item.fields.description || '',
			features: item.fields.features
				? item.fields.features.split('\n').filter(f => f.trim())
				: [],
			category: item.fields.category?.toLowerCase() || 'all',
			featured: item.fields.featured || false,
			order: item.fields.order || 999
		}));
	} catch (error) {
		console.error('Error fetching packages from Contentful:', error);
		return [];
	}
};
export default client;
